module.exports = __webpack_public_path__ + "static/media/noun-spa-2528450-142350.505080f8.svg";